
import React, { useEffect, useMemo, useState } from 'react';
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
import { Routes } from "routes";
import { jwtDecode } from 'jwt-decode';

// pages
import Presentation from "pages/Presentation";
import DashboardOverview from "pages/dashboard/DashboardOverview";
// import DashboardTraffic from "pages/dashboard/DashboardTraffic";
// import DashboardProductAnalysis from "pages/dashboard/DashboardProductAnalysis";
// import Kanban from 'pages/Kanban';
// import Messages from "pages/Messages";
// import SingleMessage from "pages/SingleMessage";
// import Users from "pages/Users";
// import Transactions from "pages/Transactions";
// import Tasks from "pages/Tasks";
// import Settings from "pages/Settings";
// import Calendar from "pages/Calendar";
// import MapPage from "pages/Map";
// import Pricing from "pages/examples/Pricing";
// import Billing from "pages/examples/Billing";
// import Invoice from "pages/examples/Invoice";
import Signin from "pages/examples/Signin";
import Signup from "pages/examples/Signup";
import ForgotPassword from "pages/examples/ForgotPassword";
import ResetPassword from "pages/examples/ResetPassword";
import Lock from "pages/examples/Lock";
// import Widgets from "pages/examples/Widgets";
import NotFoundPage from "pages/examples/NotFound";
import ServerError from "pages/examples/ServerError";

// documentation pages
// import DocsOverview from "pages/documentation/DocsOverview";
// import DocsDownload from "pages/documentation/DocsDownload";
// import DocsQuickStart from "pages/documentation/DocsQuickStart";
// import DocsLicense from "pages/documentation/DocsLicense";
// import DocsFolderStructure from "pages/documentation/DocsFolderStructure";
// import DocsBuild from "pages/documentation/DocsBuild";
// import DocsChangelog from "pages/documentation/DocsChangelog";

// plugin pages
// import PluginCharts from "pages/plugins/Charts";
// import PluginCalendar from "pages/plugins/Calendar";
// import PluginDatatable from "pages/plugins/Datatable";
// // import PluginMap from "pages/plugins/Map";
// import PluginDropzone from "pages/plugins/Dropzone";
// import PluginSweetAlert from "pages/plugins/SweetAlert";

// components
import Sidebar from 'components/Sidebar';
import Topbar from 'components/Topbar';
import Footer from 'components/Footer';

// import Accordion from "pages/components/Accordion";
// import Alerts from "pages/components/Alerts";
// import Badges from "pages/components/Badges";
// import Breadcrumbs from "pages/components/Breadcrumbs";
// import Buttons from "pages/components/Buttons";
// import Forms from "pages/components/Forms";
// import Modals from "pages/components/Modals";
// import Navs from "pages/components/Navs";
// import Navbars from "pages/components/Navbars";
// import Pagination from "pages/components/Pagination";
// import Popovers from "pages/components/Popovers";
// import Progress from "pages/components/Progress";
// import Tables from "pages/components/Tables";
// import Tabs from "pages/components/Tabs";
// import Tooltips from "pages/components/Tooltips";
// import Toasts from "pages/components/Toasts";
// import WidgetsComponent from "pages/components/Widgets";
import UserOnboarding from './userOnboarding/UserOnboarding';
import SMSRegistration from './smsRegistration/SMSRegistration';
import SMSCRegistration from './smscRegistration/SMSCRegistration';

import ContactList from './contactList/ContactList';
import Wallet from './wallet/Wallet'
import Template from './template/TemplateTables';
import CreateTemplate from './template/CreateTemplate';
import ChannelTesting from './channelTesting/ChannelTesting';
import campaignList from './campaigns/campaignList';
import campaignCreate from './campaigns/campaignCreate';
import routeManagement from './routeManagement/routeManagement';
import msgRate from './messageRate/msgRate';
import rcsBspManagement from './routeManagement/rcs/rcsBspManagement';
import rcsRateManagement from './messageRate/rcs/rcsRateManagement';
import summary from './reports/campaignSum';
import ChatBot from './chatBot/ChatBot';
import CreateSMS from './smsRegistration/CreateSMS';
import ChatBotFlowScreen from 'chatBOTflow/mainScreen';
import CreateUserOnboarding from './userOnboarding/CreateUserOnboarding';
import CreateSMSC from './smscRegistration/CreateSMSC';
import SMSCRateManagement from './smscRateManagement/SMSCRateManagement';
import CreateRateManagement from './smscRateManagement/CreateRateManagement';
import MappingTables from './mapping/RouteMapped';
// import messages from 'data/messages';
import SMSVendorOnboarding from './smsVendorOnboarding/SMSVendorOnboarding';
import CreateSMSVendor from './smsVendorOnboarding/CreateSMSVendor';
import DefaultTable from './routing/Default/DefaultTable';
import CreateDefault from './routing/Default/CreateDefault';
import CreateDefaultRoutingSMSC from './routing/Default/SelectSMSCs';
import vendorWallet from './wallet/vendorWallet';
import CreateRouteMapping from './mapping/CreateRouteMapping';
import smsc from './systemMonitor/smsc';
import esme from './systemMonitor/esme';
import profilesWA from './profilesWA/profilesWA';
import RUmapped from './mapping/RUmapped';
import reportSMS from './reports/reportSMS';
import reportWhatsapp from './reports/reportWhatsapp';
import createRUmapping from './mapping/createRUmapping';
import failover from './reports/failover';
import senderIdList from './senderId/senderIdList';
import createSenderId from './senderId/createSenderId';
import reportRCS from './reports/reportRCS';
import AddApi from './chatBot/AddApi';

const isTokenExpired = (token) => {
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000);
    return decodedToken.exp < currentTime;
  } catch (e) {
    return true;
  }
};

const RouteWithSidebar = ({ component: Component, requiredPermission, path, ...rest }) => {
  const history = useHistory();

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') !== 'false';
  };

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible());

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  };

  const getToken = () => {
    const storedTokenData = JSON.parse(localStorage.getItem('TOKEN'));
    return storedTokenData?.token;
  };


  const token = getToken();
  const userType = token ? jwtDecode(token).user_type : null;
  localStorage.setItem('userType', userType);

  const permissions = JSON.parse(localStorage.getItem("TOKEN")).features;

  const permissionMap = useMemo(() => {
    const map = {};
    permissions.forEach(p => map[p.name] = p);
    return map;
  }, [permissions]);

  const hasPermission = (feature, action) => {
    return permissionMap[feature]?.[action] === true;
  };

  const isAuthorized = !requiredPermission || hasPermission(requiredPermission.feature, requiredPermission.action);

  const getParentRoute = () => {
    const segments = path.split('/').filter(Boolean);
    if (segments.length > 1) {
      return '/' + segments[0]; // assumes structure like "/dashboard/overview"
    }
    return null;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!token || isTokenExpired(token)) {
        localStorage.removeItem("TOKEN");
        window.location.href = Routes.Presentation.path;
      }
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, [token]);

  return (
    <Route
      {...rest}
      render={props => {
        // If token is not present or expired, redirect to login page
        if (!token || isTokenExpired(token)) {
          history.push(Routes.Presentation.path);
          localStorage.removeItem("TOKEN"); // Clear expired token from localStorage
        }
        if (!isAuthorized) {
          history.push(Routes.NotFound.path);
        }

        return (
          <>
            <Sidebar />
            <main className="content d-flex flex-column" style={{ minHeight: '100vh' }}>
              <Topbar contentName={requiredPermission.feature} backPath={getParentRoute()} isCreate={requiredPermission.action} />
              <div className="flex-grow-1 main-content">
                <Component {...props} />
              </div>
              <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
            </main>
          </>
        );
      }}
    />
  );
};

export default () => (
  <Switch>
    <Route exact path={Routes.Presentation.path} component={Presentation} />
    <Route exact path={Routes.Signin.path} component={Signin} />
    <Route exact path={Routes.Signup.path} component={Signup} />
    <Route exact path={Routes.ForgotPassword.path} component={ForgotPassword} />
    <Route exact path={Routes.ResetPassword.path} component={ResetPassword} />
    <Route exact path={Routes.Lock.path} component={Lock} />
    <Route exact path={Routes.NotFound.path} component={NotFoundPage} />
    <Route exact path={Routes.ServerError.path} component={ServerError} />

    {/* PAGES */}

    <RouteWithSidebar
      exact
      path={Routes.Dashboard.path}
      component={DashboardOverview}
      requiredPermission={{ feature: "Dashboard", action: "read" }}
    />
   
    <RouteWithSidebar
      exact
      path={Routes.CampaignAnalytics.path}
      component={summary}
      requiredPermission={{ feature: "Campaign Analytics", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.FailOverAnalytics.path}
      component={failover}
      requiredPermission={{ feature: "FailOver Analytics", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.SMSReports.path}
      component={reportSMS}
      requiredPermission={{ feature: "SMS Reports", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.WhatsAppReports.path}
      component={reportWhatsapp}
      requiredPermission={{ feature: "WhatsApp Reports", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.RCSReports.path}
      component={reportRCS}
      requiredPermission={{ feature: "RCS Reports", action: "read" }}
    />


    <RouteWithSidebar
      exact
      path={Routes.UserManagement.path}
      component={UserOnboarding}
      requiredPermission={{ feature: "User Management", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.CreateUserManagement.path}
      component={CreateUserOnboarding}
      requiredPermission={{ feature: "User Management", action: "edit" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.SMSSMPPAccount.path}
      component={SMSRegistration}
      requiredPermission={{ feature: "SMS SMPP Account", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.CreateSMS.path}
      component={CreateSMS}
      requiredPermission={{ feature: "SMS SMPP Account", action: "edit" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.SMSCRegistration.path}
      component={SMSCRegistration}
      requiredPermission={{ feature: "SMSC Registration", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.CreateSMSC.path}
      component={CreateSMSC}
      requiredPermission={{ feature: "SMSC Registration", action: "edit" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.SMSCRates.path}
      component={SMSCRateManagement}
      requiredPermission={{ feature: "SMSC Rates", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.CreateSMSCRateManagement.path}
      component={CreateRateManagement}
      requiredPermission={{ feature: "SMSC Rates", action: "edit" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.WABSPs.path}
      component={routeManagement}
      requiredPermission={{ feature: "WA BSPs", action: "read" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.WARates.path}
      component={msgRate}
      requiredPermission={{ feature: "WA Rates", action: "read" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.RCSBSPs.path}
      component={rcsBspManagement}
      requiredPermission={{ feature: "RCS BSPs", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.RCSRates.path}
      component={rcsRateManagement}
      requiredPermission={{ feature: "RCS Rates", action: "read" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.SenderIDRegistration.path}
      component={senderIdList}
      requiredPermission={{ feature: "SenderID Registration", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.CreateSenderId.path}
      component={createSenderId}
      requiredPermission={{ feature: "SenderID Registration", action: "edit" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.RoutesMapping.path}
      component={MappingTables}
      requiredPermission={{ feature: "Routes Mapping", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.CreateMapping.path}
      component={CreateRouteMapping}
      requiredPermission={{ feature: "Routes Mapping", action: "edit" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.ReportingUser.path}
      component={RUmapped}
      requiredPermission={{ feature: "Reporting User", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={`${Routes.CreateRUMapping.path}/:id?`}
      component={createRUmapping}
      requiredPermission={{ feature: "Reporting User", action: "edit" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.VendorManagement.path}
      component={SMSVendorOnboarding}
      requiredPermission={{ feature: "Vendor Management", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.CreateVendorOnboarding.path}
      component={CreateSMSVendor}
      requiredPermission={{ feature: "Vendor Management", action: "edit" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.Routing.path}
      component={DefaultTable}
      requiredPermission={{ feature: "Routing", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.CreateDefaultRouting.path}
      component={CreateDefault}
      requiredPermission={{ feature: "Routing", action: "edit" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.CreateDefaultRoutingSMSC.path}
      component={CreateDefaultRoutingSMSC}
      requiredPermission={{ feature: "Routing", action: "edit" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.EnterpriseWallet.path}
      component={Wallet}
      requiredPermission={{ feature: "Enterprise Wallet", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.VendorWallet.path}
      component={vendorWallet}
      requiredPermission={{ feature: "Vendor Wallet", action: "read" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.ChannelTesting.path}
      component={ChannelTesting}
      requiredPermission={{ feature: "Channel Testing", action: "read" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.ESMEList.path}
      component={esme}
      requiredPermission={{ feature: "ESME List", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.SMSCList.path}
      component={smsc}
      requiredPermission={{ feature: "SMSC List", action: "read" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.ContactList.path}
      component={ContactList}
      requiredPermission={{ feature: "Contact List", action: "read" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.Templates.path}
      component={Template}
      requiredPermission={{ feature: "Templates", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.CreateTemplate.path}
      component={CreateTemplate}
      requiredPermission={{ feature: "Templates", action: "edit" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.Campaign.path}
      component={campaignList}
      requiredPermission={{ feature: "Campaign", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.CreateCampaign.path}
      component={campaignCreate}
      requiredPermission={{ feature: "Campaign", action: "edit" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.WAProfiles.path}
      component={profilesWA}
      requiredPermission={{ feature: "WA Profiles", action: "read" }}
    />

    <RouteWithSidebar
      exact
      path={Routes.ChatBot.path}
      component={ChatBot}
      requiredPermission={{ feature: "ChatBot", action: "read" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.ChatFlowScreen.path}
      component={ChatBotFlowScreen}
      requiredPermission={{ feature: "ChatBot", action: "edit" }}
    />
    <RouteWithSidebar
      exact
      path={Routes.ChatBotApi.path}
      component={AddApi}
      requiredPermission={{ feature: "ChatBot", action: "edit" }}
    />
  </Switch>
);
